package com.schoolconnect.app.feature.eventsnews

import com.schoolconnect.app.feature.attendance.ParentAttendanceChild
import com.schoolconnect.app.feature.common.PaginationPolicy

data class ParentEventsNewsState(
    val children: List<ParentAttendanceChild> = emptyList(),
    val selectedChildIndex: Int = 0,
    val rows: List<EventRowUi> = emptyList(),
    val isLoading: Boolean = true,
    val errorMessage: String = "",
    val totalCount: Int = 0,
    val search: String = "",
    val period: String = "All",
    val periodFrom: String = "",
    val periodTo: String = "",
    val status: String = "Active",
    val pageIndex: Int = 0,
    val pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
    val sortField: EventsSortField = EventsSortField.PUBLISHED_DATE,
    val sortAscending: Boolean = false,
    val viewing: EventRowUi? = null,
    val isViewingLoading: Boolean = false,
    val viewingError: String = ""
) {
    val selectedChild: ParentAttendanceChild? get() = children.getOrNull(selectedChildIndex)
}

sealed interface ParentEventsNewsEvent {
    data class ChildSelected(val index: Int) : ParentEventsNewsEvent
    data class SearchChanged(val value: String) : ParentEventsNewsEvent
    data class PeriodChanged(val value: String) : ParentEventsNewsEvent
    data class CustomPeriodChanged(val from: String, val to: String) : ParentEventsNewsEvent
    data class StatusChanged(val value: String) : ParentEventsNewsEvent
    data object FiltersCleared : ParentEventsNewsEvent
    data class PageChanged(val index: Int) : ParentEventsNewsEvent
    data class PageSizeChanged(val size: Int) : ParentEventsNewsEvent
    data class SortChanged(val field: EventsSortField) : ParentEventsNewsEvent
    data class ViewRequested(val row: EventRowUi) : ParentEventsNewsEvent
    data object ViewDismissed : ParentEventsNewsEvent
}
